import service from '@/utils/server';

const modName='/yard/recovery/';
const downloadFileModeName = '/common/web/download/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};

//新增方法
export const saveData = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  });
};
//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'initUpdate/' + data,
    method: 'post',
    data
  });
};
//修改产品类型提交方法
export const editData = data => {
  return service({
    url: modName + 'updateBoxCondition',
    method: 'post',
    data
  });
};
//删除方法
export const deleteData = data => {
  return service({
    url: modName + 'delete/'+data.id,
    method: 'post',
    data
  });
};

//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};
//预览pdf
export const printPdf = data => {
  return service({
    url: modName + 'printPdfSearch/' + data,
    method: 'post'
  });
};


//回单上传路径
export const uploadUrl = process.env.BASE_URL + modName + 'uploadSubmit';

//订单回单上传
export const printUploadSubmit = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return service({
    ...config,
    url: modName + 'uploadSubmit',
    method: 'post',
    data
  });
};

//回单预览
export const podShow = data => {
  return service({
    url: modName + 'preview',
    method: 'post',
    data
  });
};

//文件下载
export const fileDownload = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: downloadFileModeName + 'file/'+data,
    method: 'post',
    data
  });
};

//明细-预览pdf
export const printSkuPdf = data => {
  return service({
    url: modName + 'printPdfSkuSearch/' + data,
    method: 'post'
  });
};


//发货单打印记录打印操作
export const doPrint = data => {
  return service({
    url: modName + 'doPrint',
    method: 'post',
    data
  });
};
//初始化更新对象
export const initBusinessType = data => {
  return service({
    url: modName + 'initBusinessType/' + data,
    method: 'post',
    data
  });
};


//gatePass上传
export const uploadGatepassUrl = process.env.BASE_URL + modName + 'uploadGatePassSubmit';

//gatePass上传
export const uploadGatePassSubmit = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return service({
    ...config,
    url: modName + 'uploadGatePassSubmit',
    method: 'post',
    data
  });
};

//查询发货单历史记录
export const selectFileInfo = data => {
  return service({
    url: modName + 'selectFileInfo',
    method: 'post',
    data
  });
};

//查询gatepass上传记录历史记录
export const selectGatepassInfo = data => {
  return service({
    url: modName + 'selectGatepassInfo',
    method: 'post',
    data
  });
};


//删除上传记录
export const deleteFileInfo = data => {
  return service({
    url: modName + 'deleteFile',
    method: 'post',
    data
  });
};

//查询产品列表
export const findListByCustomerAndSku = data => {
  return service({
    url: modName + 'findListByCustomerAndSku',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/yard/recovery/api/index.js